<div *ngIf="shouldShowErrors()">
  <div class="invalid animated fadeIn">{{listOfErrors()[0]}}</div>
</div>
